export default {
  title: 'Payout reports',
  tableHeaderActionTooltip: 'Create new Payout report',
  dialog: {
    title: {
      generateReport: 'Generate Payout report',
      deleteReport: 'Delete Payout report',
      cancelReport: 'Cancel Payout report',
      regenerateReport: 'Regenerate Payout report',
      retryReport: 'Retry Payout report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Payout report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter Payout report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Statuses',
      placeholder: 'Select statuses'
    },
    operationIds: {
      label: 'Operation Ids',
      placeholder: 'Select operation Ids'
    },
    msisdns: {
      label: 'Phone number(s)',
      placeholder: 'Phone number(s)'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    operationIds: {
      label: 'Operation Id(s)'
    },
    msisdns: {
      label: 'Phone number(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
